import { render, staticRenderFns } from "./synthesize-contract.html?vue&type=template&id=8b87a108&scoped=true&external"
import script from "./synthesize-contract.js?vue&type=script&lang=js&external"
export * from "./synthesize-contract.js?vue&type=script&lang=js&external"
import style0 from "./synthesize-contract.scss?vue&type=style&index=0&id=8b87a108&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b87a108",
  null
  
)

export default component.exports